import React from 'react'
import $ from 'jquery'

import { logout } from '../services/auth'
import { URL } from '../constants/index'
import LogoBranco from '../assets/LogoBranco.png';

const NavBIMobile = ({ menu, history }) => {

  const onLogout = () => {
    logout()
      .then(res => history.push(URL.URLLogin))
      .catch(res => history.push(URL.URLLogin))
  }

  const getMenuDashboard = (linkMenu) => {
    if (!linkMenu) return;
    if ($(".powerbi-frame").length === 0) return;
    var report = window.powerbi.get($(".powerbi-frame")[0]);
    report.setPage(linkMenu).catch(err => console.log(err));
  }

  return (
    <div className="mobile-topbar-container">
      <div className="mobile-topbar-header">
        <div className="topbar-brand">
          <img src={LogoBranco} alt="Logo" className="topbar-logo" />
          <span className="topbar-title">Dashboard</span>
        </div>
        <button className="btn-topbar-logout mobile-logout-btn" onClick={onLogout} title="Sair">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
            <polyline points="16 17 21 12 16 7"></polyline>
            <line x1="21" y1="12" x2="9" y2="12"></line>
          </svg>
        </button>
      </div>
      <div className="mobile-topbar-nav">
        <select 
          className="modern-select mobile-select" 
          onChange={(e) => getMenuDashboard(e.target.value)}
          defaultValue=""
        >
          <option value="" disabled>Selecione um Dashboard...</option>
          {menu && menu.map((m, i) => (
            <option key={i} value={m.link}>{m.menu}</option>
          ))}
        </select>
      </div>
    </div>
  )
}

export default NavBIMobile;
